export enum AccountPageAppFlow {
  Shop = 'National',
  Ebookshelf = 'eBookshelf',
  Connect = 'Standalone Connect',
  ClassicConnect = 'classicConnect',
  Dfa = 'First Aid Forward',
  ClinicalReasoning = 'clinicalReasoning',
  NutriCalc = 'Nutritioncalc',
  APR = 'APR',
  caas = "caas",
  Create = "create",
  LTIA = "LMS Connect"
}
